import React, { useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import SelectDropDown from '../../../../components/elements/SelectDropDown'

function FilterMovements({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const [category , setCategory] = useState('')
    const [subcategory , setSubCategory] = useState('')
    const [material , setMaterial] = useState('')
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "24px 0px 10px 0px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }

            <div className='div_filter' style={{alignItems: "normal"}} >
                <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`}  style={{fontSize: "13px"}} >
                    <SelectDropDown
                        options={[{ value: 'active', label: "active" }, { value: 'unactive', label: "unactive" }]}
                        varr={category}
                        setVarr={setCategory}
                        placeholder={translate('category')}
                    />
                </div>
                <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} style={{fontSize: "13px"}} >
                    <SelectDropDown
                        options={[{ value: 'active', label: "active" }, { value: 'unactive', label: "unactive" }]}
                        varr={subcategory}
                        setVarr={setSubCategory}
                        placeholder={translate('sub_categories')}
                    />
                </div>
                <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} style={{fontSize: "13px"}} >
                    <SelectDropDown
                        options={[{ value: 'active', label: "active" }, { value: 'unactive', label: "unactive" }]}
                        varr={material}
                        setVarr={setMaterial}
                        placeholder={translate('materials')}
                    />
                </div>
                <button className='btn_filter' >
                    {
                        `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterMovements